const cities = [
  { id:1,  state_id:1, city_name:"Chennai"            },
  { id:2,  state_id:1, city_name:"Madurai"             },
  { id:3,  state_id:1, city_name:"Coimbatore"          },
  { id:4,  state_id:1, city_name:"Trichy"              },
  { id:5,  state_id:2, city_name:"Bengaluru"           },
  { id:6,  state_id:2, city_name:"Mysuru"              },
  { id:7,  state_id:3, city_name:"Kochi"               },
  { id:8,  state_id:3, city_name:"Thiruvananthapuram"  },
  { id:9,  state_id:4, city_name:"Visakhapatnam"       },
  { id:10, state_id:4, city_name:"Vijayawada"          },
  { id:11, state_id:5, city_name:"Hyderabad"           },
  { id:12, state_id:6, city_name:"Mumbai"              },
  { id:13, state_id:6, city_name:"Pune"                },
];
export default cities;